import { useState } from "react";
import { auth, googleProvider } from "../network/firebaseConfig";
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signInWithPopup,
    updateProfile,
} from "firebase/auth";
import RegistrationUserClass from "../network/registration.nt";
import UserService from "../network/userService";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const LoginRegistration = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("login");
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            if (activeTab === "register") {
                if (formData.password !== formData.confirmPassword) {
                    toast.error("Passwords do not match!");
                    setLoading(false);
                    return;
                }

                const res = await createUserWithEmailAndPassword(
                    auth,
                    formData.email,
                    formData.password
                );

                await updateProfile(res.user, { displayName: formData.name });

                // ✅ Store in "users" collection (custom form registration)
                await UserService.addUser({
                    uid: res.user.uid,
                    email: res.user.email,
                    name: formData.name,
                    method: "email",
                });

                toast.success("Registration successful!");
                navigate("/")
            } else {
                let res = await signInWithEmailAndPassword(
                    auth,
                    formData.email,
                    formData.password
                );

                if (res.user.uid) {
                    toast.success("Login successful!");
                    navigate("/")
                }
            }
        } catch (error) {
            console.error(error);
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleLogin = async () => {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;

            // ✅ Store in "registered_users" collection (social login)
            await RegistrationUserClass.addUser({
                uid: user.uid,
                email: user.email,
                name: user.displayName,
                method: "google",
            });

            toast.success("Logged in with Google!");
        } catch (error) {
            console.error(error);
            toast.error(error.message);
        }
    };

    return (
        <div className="auth-tab-wrapper">
            <div className="container">
                {/* Tabs */}
                <div className="tabs">
                    <button
                        id="loginTab"
                        className={activeTab === "login" ? "active" : ""}
                        onClick={() => setActiveTab("login")}
                    >
                        Login
                    </button>
                    <button
                        id="registerTab"
                        className={activeTab === "register" ? "active" : ""}
                        onClick={() => setActiveTab("register")}
                    >
                        Register
                    </button>
                </div>

                {/* LOGIN FORM */}
                <form
                    className={`form ${activeTab === "login" ? "active" : ""}`}
                    onSubmit={handleSubmit}
                >
                    <input
                        name="email"
                        type="email"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                        className='focus:outline-1 outline-gray-300'
                    />

                    <div className="relative">
                        <input
                            name="password"
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            required
                            onChange={handleChange}
                            className='focus:outline-1 outline-gray-300'
                        />
                        <span
                            className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer text-sm text-gray-600"
                            onClick={() => setShowPassword((prev) => !prev)}
                        >
                            {showPassword ? "Hide" : "Show"}
                        </span>
                    </div>

                    <button type="submit" className="btn" disabled={loading}>
                        {loading ? "Logging in..." : "Login"}
                    </button>

                    <p className="or">Or continue with</p>
                    <div className="socials">
                        <button
                            type="button"
                            className="social"
                            onClick={handleGoogleLogin}
                        >
                            G
                        </button>
                        <button type="button" className="social">f</button>
                        <button type="button" className="social">t</button>
                    </div>
                </form>

                {/* REGISTER FORM */}
                <form
                    className={`form ${activeTab === "register" ? "active" : ""}`}
                    onSubmit={handleSubmit}
                >
                    <input
                        name="name"
                        type="text"
                        placeholder="Full Name"
                        required
                        onChange={handleChange}
                        className='focus:outline-1 outline-gray-300'
                    />
                    <input
                        name="email"
                        type="email"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                        className='focus:outline-1 outline-gray-300'
                    />

                    <div className="relative">
                        <input
                            name="password"
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            required
                            onChange={handleChange}
                            className='focus:outline-1 outline-gray-300'
                        />
                        <span
                            className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer text-sm text-gray-600"
                            onClick={() => setShowPassword((prev) => !prev)}
                        >
                            {showPassword ? "Hide" : "Show"}
                        </span>
                    </div>

                    <div className="relative">
                        <input
                            name="confirmPassword"
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm Password"
                            required
                            onChange={handleChange}
                            className='focus:outline-1 outline-gray-300'
                        />
                        <span
                            className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer text-sm text-gray-600"
                            onClick={() => setShowConfirmPassword((prev) => !prev)}
                        >
                            {showConfirmPassword ? "Hide" : "Show"}
                        </span>
                    </div>

                    <button type="submit" className="btn" disabled={loading}>
                        {loading ? "Registering..." : "Register"}
                    </button>

                    <p className="or">Or sign up with</p>
                    <div className="socials">
                        <button
                            type="button"
                            className="social"
                            onClick={handleGoogleLogin}
                        >
                            G
                        </button>
                        <button type="button" className="social">f</button>
                        <button type="button" className="social">t</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginRegistration;


// import { useState } from "react";
// import { auth, googleProvider } from "../network/firebaseConfig";
// import {
//     createUserWithEmailAndPassword,
//     signInWithEmailAndPassword,
//     signInWithPopup,
//     updateProfile,
// } from "firebase/auth";
// import RegistrationUserClass from "../network/registration.nt";
// import { addDoc, serverTimestamp } from "firebase/firestore";
// import userService from "../network/userService";

// const AuthTabs = () => {
//     const [activeTab, setActiveTab] = useState("login");
//     const [loading, setLoading] = useState(false);
//     const [formData, setFormData] = useState({
//         name: "",
//         email: "",
//         password: "",
//         confirmPassword: "",
//     });

//     const handleChange = (e) =>
//         setFormData({ ...formData, [e.target.type]: e.target.value });

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);

//         try {
//             if (activeTab === "register") {
//                 if (formData.password !== formData.confirmPassword) {
//                     alert("Passwords do not match!");
//                     setLoading(false);
//                     return;
//                 }

//                 const res = await createUserWithEmailAndPassword(auth, formData.email, formData.password);
//                 await updateProfile(res.user, { displayName: formData.name });

//                 await userService.addUser({
//                     uid: res.user.uid,
//                     email: res.user.email,
//                     name: formData.name,
//                 });

//                 alert("Registration successful!");
//             } else {
//                 await signInWithEmailAndPassword(auth, formData.email, formData.password);
//                 alert("Login successful!");
//             }
//         } catch (error) {
//             console.error(error);
//             alert(error.message);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleGoogleLogin = async () => {
//         try {
//             const result = await signInWithPopup(auth, googleProvider);
//             const user = result.user;
//             await RegistrationUserClass.addUser({
//                 uid: user.uid,
//                 email: user.email,
//                 name: user.displayName,
//             });
//             alert("Logged in with Google!");
//         } catch (error) {
//             console.error(error);
//             alert(error.message);
//         }
//     };

//     return (
//         <div className="auth-tab-wrapper">
//             <div className="container">
//                 <div className="tabs">
//                     <button
//                         id="loginTab"
//                         className={activeTab === "login" ? "active" : ""}
//                         onClick={() => setActiveTab("login")}
//                     >
//                         Login
//                     </button>
//                     <button
//                         id="registerTab"
//                         className={activeTab === "register" ? "active" : ""}
//                         onClick={() => setActiveTab("register")}
//                     >
//                         Register
//                     </button>
//                 </div>

//                 <form className={`form ${activeTab === "login" ? "active" : ""}`} onSubmit={handleSubmit}>
//                     <input
//                         type="email"
//                         placeholder="Email"
//                         required
//                         onChange={handleChange}
//                     />
//                     <input
//                         type="password"
//                         placeholder="Password"
//                         required
//                         onChange={handleChange}
//                     />
//                     <button type="submit" className="btn" disabled={loading}>
//                         {loading ? "Logging in..." : "Login"}
//                     </button>
//                     <p className="or">Or continue with</p>
//                     <div className="socials">
//                         <button type="button" className="social" onClick={handleGoogleLogin}>
//                             G
//                         </button>
//                         <button type="button" className="social">f</button>
//                         <button type="button" className="social">t</button>
//                     </div>
//                 </form>

//                 <form className={`form ${activeTab === "register" ? "active" : ""}`} onSubmit={handleSubmit}>
//                     <input type="text" placeholder="Full Name" required onChange={handleChange} />
//                     <input type="email" placeholder="Email" required onChange={handleChange} />
//                     <input type="password" placeholder="Password" required onChange={handleChange} />
//                     <input type="password" placeholder="Confirm Password" required onChange={handleChange} />
//                     <button type="submit" className="btn" disabled={loading}>
//                         {loading ? "Registering..." : "Register"}
//                     </button>
//                     <p className="or">Or sign up with</p>
//                     <div className="socials">
//                         <button type="button" className="social" onClick={handleGoogleLogin}>
//                             G
//                         </button>
//                         <button type="button" className="social">f</button>
//                         <button type="button" className="social">t</button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default AuthTabs;


